<template>
  <group :title="title">
    <repeater-group @add="() => model.push({})">
      <repeater v-for="(value, index) in model" :key="index" :index="index" @remove="(index) => model.splice(index, 1)">
        <text-input label="Value" v-model="model[index].register" />
        <v-select label="Product" v-model="model[index].product">
          <option value="gal1">Gal 1</option>
          <option value="gal3">Gal 3</option>
          <option value="gal5">Gal 5</option>
          <option value="rinse">Rinse</option>
        </v-select>
        <v-select label="Trigger vend only on" v-model="model[index].trigger_only_on">
          <option value="1">1</option>
          <option value="0">0</option>
          <option value="any_change">Any change</option>
        </v-select>
      </repeater>
    </repeater-group>
  </group>
</template>

<script>
import Group from '@/views/settings/machine-profile/Group'
import RepeaterGroup from '@/views/settings/machine-profile/RepeaterGroup'
import Repeater from '@/views/settings/machine-profile/Repeater'
import TextInput from '@/components/form/Text.vue'
import { ref, watch } from 'vue'
import VSelect from '@/components/form/Select'

export default {
  name: 'WaterProducts',

  components: {
    VSelect,
    Repeater,
    RepeaterGroup,
    Group,
    TextInput,
  },

  props: ['modelValue', 'title'],

  setup(props, { emit }) {
    const model = ref(props.modelValue)

    watch(
      () => model,
      (v) => emit('update:modelValue', v)
    )

    return {
      model,
    }
  }
}
</script>

<style scoped>

</style>
